import script from "./RootRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./RootRoute.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__